import {ObjectDTO} from "../object-dto";

export class TypeEquipementPmsDto extends ObjectDTO {
  libelle: string;
}
